import {TreeViewBaseItem} from '@mui/x-tree-view';
import {t} from 'i18next';
import {ISearchTreeResponse} from '../api/types/redactions.type';
import {ExtendedTreeItemProps} from '../shared/interfaces';
import {isEmpty} from 'lodash';

const getLabelText = (item: any) => {
  return `${item.searchPureHits > 0 ? t('batchRedactions.tree.searchHitCount') + item.searchPureHits : ''} ${item.lastExecution ? '(' + item.lastExecution + ')' : ''} ${item.numRedactionDocs > 0 ? t('batchRedactions.tree.redactableDocuments') + item.numRedactionDocs : ''} ${item.batchRedactingText || ''}`;
};

const getButtonText = (item: ISearchTreeResponse) => {
  return (
    item.analyzeGroupButtonText ||
    item.viewAndRedactButton ||
    item.analyzeButtonText
  );
};

export const formatRedactionTreeData = (
  apiData: Array<ISearchTreeResponse>
): TreeViewBaseItem<ExtendedTreeItemProps>[] => {
  const lookup: Record<string, TreeViewBaseItem<ExtendedTreeItemProps>> = {};
  const rootNodes: TreeViewBaseItem<ExtendedTreeItemProps>[] = [];

  for (const item of apiData) {
    lookup[item.id] = {
      id: item.id,
      label: item.text,
      isGroup: item.isGroup,
      parentGroupId: item.parent,
      name: item.text?.replaceAll(/\s+/g, '_').toLocaleLowerCase(),
      actionButtonName: getButtonText(item),
      actionButtonLabel: getLabelText(item),
      showActionButtonWithLabel: !item.isAnalyzing,
      showProgress:
        item.isAnalyzing &&
        isEmpty(getButtonText(item)) &&
        isEmpty(item.batchRedactingText),
      progressPercentage: item.percentage,
      buttonLabelTooltipTitle: item.helpTitleHitCount,
      buttonLabelTooltipContent: item.helpTitleHitCount,
      children: [],
    };
  }

  for (const item of apiData) {
    if (item.parent && item.parent !== '#' && lookup[item.parent]) {
      lookup[item.parent].children!.push(lookup[item.id]);
    } else {
      rootNodes.push(lookup[item.id]);
    }
  }

  return rootNodes;
};

export const getAllIdsForNode = (
  nodes: TreeViewBaseItem<ExtendedTreeItemProps>[],
  selectednodeId?: string
): string[] => {
  let ids: string[] = [];

  nodes.forEach((item) => {
    if (item.isGroup === false) {
      ids.push(item.id);
    }
    // Recursively process children regardless of item.isGroup,
    // because children may also have isGroup false and nested deeper.
    if (item.children && item.children.length > 0) {
      ids = ids.concat(getAllIdsForNode(item.children));
    }
  });

  return ids.length > 0 ? ids : [selectednodeId!];
};
